import script from "./CombinationDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CombinationDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CombinationDialog.vue?vue&type=style&index=0&id=45028cb4&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45028cb4"]])

export default __exports__